import React from 'react';
import Onboarding from '../Onboarding';

const ModalOnboarding = () => {
  return <Onboarding inSession={true} isReconnect={true} />;
};

export default ModalOnboarding;
